import { render, staticRenderFns } from "./ClientsSettingsPm.vue?vue&type=template&id=7f611e1e&"
import script from "./ClientsSettingsPm.vue?vue&type=script&lang=js&"
export * from "./ClientsSettingsPm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports